<template>
  <div class="content">
    <NavBar :navtitle="navtitle" :navBlock="navBlock"></NavBar>
    <div class="paddingContent">
      <el-row class="ListMenu">
        <el-col :span="24">
          <el-form ref="form" :model="listMenuForm" class="searchForm">
            <el-form-item class="searchItem">
              <el-select
                v-model="listMenuForm.memberStatus"
                placeholder="請選擇會員狀態"
              >
                <el-option label="昵稱" value="0"></el-option>
                <el-option label="用戶賬號" value="1"></el-option>
              </el-select>
              <el-input
                v-model="listMenuForm.searchKey"
                placeholder="在左側選擇搜索類別"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="評論關鍵字"
              class="searchItem"
              style="margin-left: 200px;"
            >
              <el-input v-model="listMenuForm.keyword"></el-input>
            </el-form-item>
            <el-form-item label="評論狀態" class="searchItem ">
              <el-select v-model="listMenuForm.status" placeholder="全部">
                <el-option label="正常" value="0"></el-option>
                <el-option label="黑名單" value="1"></el-option>
                <el-option label="敏感字符" value="2"></el-option>
                <el-option label="評論投訴" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="評論時間"
              class="searchItem hidden-lg-and-down"
            >
              <el-date-picker
                v-model="listMenuForm.time"
                type="datetimerange"
                style="width: 400px;"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <el-row class="ListMenu">
        <el-col :span="24">
          <el-form
            ref="form"
            :model="listMenuForm"
            class="searchForm  hidden-xl-only"
          >
            <el-form-item label="評論時間" class="searchItem ">
              <el-date-picker
                v-model="listMenuForm.time"
                type="datetimerange"
                style="width: 400px;"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <div class="MenuBtnWrap">
        <div class="btn" @click="search">查詢</div>
        <div class="btn borderBtn" @click="reset">重置</div>
      </div>
      <div class="tableWrap">
        <el-table :data="userInfoList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in userInfoTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
                -
              </div>
              <div v-else-if="item.prop === 'hide'">
                {{ scope.row.hide === 0 ? "未隱藏" : "隱藏" }}
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button
                @click="toHide(scope.row)"
                :disabled="scope.row.type === 1"
                type="text"
                >{{ scope.row.hide === 0 ? "隱藏" : "取消隱藏" }}</el-button
              >
              <el-button
                @click="toDeled(scope.row)"
                :disabled="scope.row.type === 1"
                type="text"
                >刪除</el-button
              >
              <!-- <el-button v-else type="text" style="color:#eee;">查看詳情</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import { throttle } from "../../directives/limit";

export default {
  data() {
    return {
      navBlock: "簽到/簽到列表",
      navtitle: "查看評論",
      userInfoList: [],
      listMenuForm: {
        startTime: "",
        endTime: "",
        status: "",
        keyword: "",
        username: "",
        nickname: "",
        memberStatus: "",
        time: []
      },
      userInfoTable: [
        {
          prop: "userId",
          label: "用戶ID",
          width: "200"
        },
        {
          prop: "username",
          label: "用戶賬號",
          width: ""
        },
        {
          prop: "nickname",
          label: "用戶昵稱",
          width: "80"
        },
        {
          prop: "content",
          label: "評論内容",
          width: "120"
        },
        {
          prop: "createTime",
          label: "評論時間",
          width: "120"
        },
        {
          prop: "status",
          label: "狀態",
          width: "170"
        },
        {
          prop: "hide",
          label: "是否隱藏",
          width: "60"
        }
      ],
      currentPage: 1,
      total: 10,
      dialogVisible: false,
      has_next:false
    };
  },
  created() {
    let _this = this;
    _this.getUserInfoList();
  },

  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取用户列表
    getUserInfoList() {
      let _this = this;
      _this
        .$get(
          `/request/earth/sign/feedback/list?page=${_this.currentPage}&size=10&id=${_this.$route.query.id}&nickname=${_this.listMenuForm.nickname}&username=${_this.listMenuForm.username}&keyword=${_this.listMenuForm.keyword}&startTime=${_this.listMenuForm.startTime}&status=${_this.listMenuForm.status}&endTime=${_this.listMenuForm.endTime}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            _this.total = res.data.allRow;
            _this.has_next=res.data.has_next
            res.data.list.forEach(v => {
              v.status =
                v.status == 0
                  ? "正常"
                  : v.status == 1
                  ? "黑名單評論"
                  : v.status == 2
                  ? "違規評論"
                  : "敏感字符";

              v.createTime = _this.$getTime(v.createTime);
            });
            _this.userInfoList = res.data.list;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getUserInfoList();
    },
    // 查询
    search() {
      if (this.listMenuForm.memberStatus == "1") {
        this.listMenuForm.username = this.listMenuForm.searchKey;
      } else if (this.listMenuForm.memberStatus === "0") {
        this.listMenuForm.nickname = this.listMenuForm.searchKey;
      }
      if (this.listMenuForm.time.length > 0) {
        this.listMenuForm.startTime = this.$getTime(this.listMenuForm.time[0]);
        this.listMenuForm.endTime = this.$getTime(this.listMenuForm.time[1]);
      }

      let _this = this;
      _this.currentPage = 1;
      _this.getUserInfoList();
    },
    // 重置
    reset() {
      let _this = this;
      _this.listMenuForm = {
        startTime: "",
        endTime: "",
        status: "",
        keyword: "",
        username: "",
        nickname: "",
        memberStatus: "",
        time: []
      };
      _this.currentPage = 1;
      _this.getUserInfoList();
    },
    //隱藏
    toHide: throttle(
      function() {
        return true;
      },
      function(e) {
        let _this = this;
        _this.$message.closeAll();
        let types = e.hide === 0 ? 1 : 2;
        const param = {
          type: types,
          id: _this.$route.query.id,
          ids: [e.id]
        };
        _this
          .$post(
            `/request/earth/sign/hide/feedback/operate`,
            param,
            _this.$GLOBAL.jsonConfig
          )
          .then(res => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              _this.dialogVisible = false;
              _this.getUserInfoList();
              this.$message({
                message: types == 1 ? "隐藏成功" : "显示成功",
                type: "success"
              });
            } else {
              _this.dialogVisible = false;
              _this.$propMessage(res.message, "error");
            }
          });
      },
      2000
    ),
    toDeled: throttle(
      function() {
        return true;
      },
      function(e) {
        let _this = this;
        _this.$message.closeAll();
        const param = {
          id: _this.$route.query.id,
          ids: [e.id]
        };
        _this
          .$post(
            `/request/earth/sign/del/feedback`,
            param,
            _this.$GLOBAL.jsonConfig
          )
          .then(res => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              if (!_this.has_next && _this.userInfoList.length == 1&&_this.currentPage>1) {
                _this.currentPage--;
              }
              _this.dialogVisible = false;
              this.$message({
                message: "删除成功",
                type: "success"
              });
              _this.getUserInfoList();
            } else {
              _this.dialogVisible = false;
              _this.$propMessage(res.message, "error");
            }
          });
      },
      2000
    )
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.content {
  .paddingContent {
    width: 100%;
    .ListMenu {
      display: flex;
    }
    .tableWrap {
      width: 100%;
      margin-top: 0.4rem;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      // .searchItem{
      //     flex: 1;
      // }
    }
    .MenuBtnWrap {
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sign/signDetail.vue